import styled from '@emotion/styled'
import ReactMarkdown from 'react-markdown'

import { getMarkdownLinkStyle, PaddingInset } from '@cash-design-system/react'
import { FormBlockerElementLegalTextElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

const MarkdownContainer = styled.div`
  color: ${props => props.theme.colors.tertiaryLabel};
  ${props => getMarkdownLinkStyle(props.theme)}
`

export const LegalTextElement = ({ text }: FormBlockerElementLegalTextElement) => {
  if (!text) {
    throw new Error('No text for LegalTextElement')
  }

  return (
    <PaddingInset>
      <MarkdownContainer>
        <ReactMarkdown children={text} />
      </MarkdownContainer>
    </PaddingInset>
  )
}
